<style lang="scss" scoped>
</style>
<style lang="scss">
.el-main {
  padding: 0; // 可以写多个style标签，不加scoped就可以当作全局的使用
}
.backHomeModal {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  top: 0;
  left: 0;
}
.backHomeInfo {
  background-color: #fff;
  border-radius: 20px;
  width: 400px;
  height: 300px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
<template>
  <div>
    <object
      type="application/x-shockwave-flash"
      data="/scratch/Code.swf"
      width="100%"
      height="850"
      id="scratch"
      style="visibility: visible;"
    >
      <param name="allowScriptAccess" value="always" />
      <param name="allowFullScreen" value="true" />
      <param name="wmode" value="opaque" />
      <param name="flashvars" :value="siteConfig" />
    </object>

  </div>
</template>

<script>
import { mapState } from 'vuex';

//  value='site_config={"sitePrefix":"/","assetPrefix":"/","assetCdnPrefix":"./","internalAPI":"./scratch/","staticFiles":"./scratch/"}'
const baseUrl = process.env.BASE_URL;
const apiHost = process.env.VUE_APP_API_URL;
const cdnPrefix = process.env.VUE_APP_CDN;
export default {
  data() {
    return {
      scripts: {
        jquery: `${baseUrl}scratch/jquery-1.9.1.min.js`,
        scratchExt: `${baseUrl}scratch/scratch_ext.js`,
        scratch: `${baseUrl}scratch/scratch.js`,
      },
      scriptDom: {},
      scratchMc: `${baseUrl}scratch/mcpi-scratch.js`,
      opener: null,
      // siteConfig: `site_config={"sitePrefix":"${apiHost}","assetPrefix":"/","assetCdnPrefix":"./","internalAPI":"${'/api/save_mc/'}","staticFiles":"./scratch/"}`,
      // siteConfig: `site_config={"sitePrefix":"https://www.dev.codepku.com/","assetPrefix":"/",
      //                           "assetCdnPrefix":"//cdn.codepku.com/","projectPrefix":"scratch/project/","internalAPI":"scratch/","staticFiles":"scratch/"}`,
      siteConfig: `site_config={"sitePrefix":"${apiHost}/api/","assetPrefix":"/","assetCdnPrefix":"${cdnPrefix}/bluebridge/material/","projectPrefix":"${
        this.$route.query.answer_id
          ? 'examinee/answer/minecraft/project/'
          : 'examination-paper/question/code-json/'
      }","internalAPI":"scratch/","staticFiles":"scratch/"}`,
      // internalAPI 配置了接口（保存），设置资源（cdn）请求
      // staticFiles 配置了此项目根目录下用于放置scratch静态资源的目录
      //assetCdnPrefix 配置了请求资源用的cdn路径，不加protocol就和当前一致
      // sitePrefix可以用来配置api请求的host
      // projectPrefix配置的是请求项目的url
      scriptReady: false,
      mcReady: false,
    };
  },
  methods: {
    loadScript(url) {
      const myScript = document.createElement('script');
      myScript.src = url;
      myScript.type = 'text/javascript';
      document.head.appendChild(myScript);
      return new Promise((resolve) => {
        myScript.onload = resolve;
      });
    },
    removeScript(myScript) {
      if (myScript) {
        document.head.removeChild(myScript);
      }
    },
    onMessageHandler(e) {
      // console.log('');
      switch (e.data.event) {
        case 'QUESTION':
            console.log('收到了问题message', e.data.data);
          break;

        default:
          break;
      }
    },

  },
  components: {},
  created() {
    const {
      answer_id,
    } = this.$route.query;
    const { opener } = window;

    window.MCPI_SERVER_URL = 'https://local.codepku.com:4715';
    const that = this;
    window.JSeditorReady = () => {
      const Scratch = document.getElementById('scratch');
      // {
      //   question_id:0, //模拟题
      //   token
      // }
      Scratch.ASsetFrom(JSON.stringify('minecraft')); //设置来源为 scratch  才能显示  回到作品页面 这个按钮
      Scratch.ASsetEditMode(1);
      Scratch.ASsetLibVersion('20160719'); //设置库版本，强制客户端刷新
      console.log('JSeditorReady');
      if (answer_id) {
        Scratch.ASloadBaseProject(answer_id, 'minecraftproject'); // 预加载代码的方法
      }
      that.mcReady = true;
      return true;
    };
  },
  async mounted() {
    await this.loadScript(this.scripts.jquery);
    await this.loadScript(this.scripts.scratchExt);
    await this.loadScript(this.scripts.scratch);
    console.log('script ready now');
    this.scriptReady = true;
  },
  beforeDestroy() {
    this.removeScript();
  },
  computed: {
    allReady() {
      return this.scriptReady && this.mcReady;
    },
  },
  props: {},
  watch: {
    allReady() {
      setTimeout(() => {
        console.log('load extension now');
        window.ScratchExtensions.loadExternalJS(this.scratchMc);
      }, 3000);
    },
  },
};
</script>
